import React from 'react';
import classnames from 'classnames';
import s from './Placeholder.scss';
var Placeholder = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height;
    return (React.createElement("div", { style: { width: width, height: height }, className: classnames(s['root'], className) }));
};
Placeholder.displayName = 'Placeholder';
export default Placeholder;
//# sourceMappingURL=Placeholder.js.map